import { Theme } from "@emotion/react";
import { KonturColors } from "@skbkontur/colors";

import { buildTheme, overrideTheme } from "./ThemeBuilder/BuildTheme";
import { IThemeTokens } from "./ThemeBuilder/ThemeTokens";

export const darkThemeTokens: IThemeTokens = {
    colors: {
        blackAndWhite: {
            primaryBackgroundColor: KonturColors.grayscaleText,
            panelBackgroundColor: "#383838",
            panelSecondaryColor: "#757575",
            panelBackgroundColorAsBlackTransparent: "#383838",
            panel2BackgroundColor: "#444444",
            panel3BackgroundColor: "#444444",
            panel2BackgroundColorAsBlackTransparent: "#444444",
            dividerColor: "rgba(255,255,255,0.1)",
            inactiveTextColor: "rgba(255,255,255,0.37)",
            secondaryTextColor: "rgba(255,255,255,0.5)",
            primaryTextColor: KonturColors.grayscaleWhiteFFF,
            invertedColors: {
                backgroundColor: KonturColors.grayscaleWhiteFFF,
                hoveredColor: "#aaaaaa",
                color: KonturColors.grayscaleText,
                inactiveColor: "rgba(0,0,0,0.37)",
            },
        },
        brand: {
            primaryColor: KonturColors.orangeBasic60,
            panelColor: KonturColors.orange80,
        },
        semantic: {
            action: {
                backgroundColor: KonturColors.blue10,
                alternativeColor: "#1F87EF",
                iconColor: KonturColors.blue90,
                color: KonturColors.mainLinkTextBlue90,
            },
            danger: {
                backgroundColor: "rgb(212,67,39)",
                alternativeColor: "#DD473B",
                iconColor: "#FF5A49",
                color: "#CB3D35",
            },
            warning: {
                backgroundColor: "#FFF0BC",
                alternativeColor: KonturColors.yellowLightBasic50,
                iconColor: KonturColors.mainWarningShapeYellow50,
                color: "#D97E00",
            },
            success: {
                backgroundColor: "#D7F8AE",
                alternativeColor: "#538A1B",
                iconColor: "#78BF2B",
                color: "#228007",
            },
        },
    },
    type: {},
    spacing: {},
};

export const darkCandyTheme: Theme = {
    candy: overrideTheme(buildTheme(darkThemeTokens), {
        rootColorScheme: "dark",
        legacy: {
            shadowColor: "rgba(0,0,0,0.5)",
        },
    }),
};
